import { Form } from "react-bootstrap";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import { useEffect, useState } from "react";
import { useTranslation } from "../hooks/useTranslation";
import { useStatsStore } from "../store/stats.store";
import {
  useYearStats,
  useCompanyYearStats,
} from "../hook/partner/statsYear.partner.hook";
import {
  useOverallStats,
  useCompanyOverallStats,
} from "../hook/partner/statsOverall.partner.hook";
import { useAuthStore } from "../store/auth.store";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import number_format from "../utils/number_format";
import OpportunitiesBusinessStatsModal from "../components/modals/opportunity/OpportunitiesBusinessStatsModal";

function BusinessStats({ company_id }) {
  const { t } = useTranslation();
  const yearStatsMutation = useYearStats();
  const overallStatsMutation = useOverallStats();
  const yearCompanyStatsMutation = useCompanyYearStats();
  const overallCompanyStatsMutation = useCompanyOverallStats();
  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);
  const currentYear = new Date().getFullYear();
  const years = [];
  const token = useAuthStore((state) => state.token);

  const yearData = useStatsStore((state) => state.yearData);
  const overallData = useStatsStore((state) => state.overallData);

  for (let year = 2009; year <= currentYear; year++) {
    years.push(year);
  }
  const [year, setYear] = useState(currentYear);
  const [stack, setStack] = useState(true);
  const [detailFilter, setDetailFilter] = useState(false);
  useEffect(() => {
    if (!company_id) {
      setPagename(t("stats.businessStats"));
      setBreadcrumbs([]);
    }
  }, []);

  useEffect(() => {
    if (token) {
      if (company_id) {
        yearCompanyStatsMutation.mutate({ token, year, company_id });
      } else {
        yearStatsMutation.mutate({ token, year });
      }
    }
  }, [token, year, company_id]);

  useEffect(() => {
    if (token) {
      if (company_id) {
        overallCompanyStatsMutation.mutate({ token, year, company_id });
      } else {
        overallStatsMutation.mutate({ token, year });
      }
    }
  }, [token, company_id]);

  Chart.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
  );

  const shortcat_number = (num) => {
    if (num > 1000000) {
      return number_format(Math.round(num / 10000) / 100, 2, ",", ".") + "M";
    } else if (num > 1000) {
      return number_format(Math.round(num / 10) / 100, 2, ",", ".") + "k";
    } else {
      return num;
    }
  };

  const tabData = (data, period, setFilterName, allYears) => {
    return (
      <>
        <div xstyle={{ overflow: "auto" }} className="sticky-table">
          <table className="table table-bordered fs-8">
            <thead>
              <tr>
                <th></th>
                {data &&
                  data[0]?.data.map((header) => (
                    <th key={header.description} className="text-center">
                      {period.periods[header.description] &&
                      parseInt(period.periods[header.description]) !== 0 ? (
                        <a
                          href="javascript:;"
                          onClick={() =>
                            setDetailFilter({
                              period: header.description,
                              company_id,
                            })
                          }
                        >
                          {header.description}
                        </a>
                      ) : (
                        header.description
                      )}
                    </th>
                  ))}
                <th className="text-center">&sum;</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((dataset) => (
                <tr key={dataset.datasetName}>
                  <td>
                    <a
                      href="javascript:;"
                      onClick={() =>
                        setDetailFilter({
                          period: allYears ? null : year,
                          company_id,
                          [setFilterName]: [dataset.datasetId],
                        })
                      }
                    >
                      {dataset.datasetName}
                    </a>
                  </td>
                  {dataset.data.map((d) => (
                    <td key={d.description} className="text-end">
                      {parseInt(d.value) === 0 ? (
                        number_format(d.value, 0, ",", ".")
                      ) : (
                        <a
                          href="javascript:;"
                          onClick={() =>
                            setDetailFilter({
                              period: d.description,
                              company_id,
                              [setFilterName]: [dataset.datasetId],
                            })
                          }
                        >
                          {number_format(d.value, 0, ",", ".")}
                        </a>
                      )}
                    </td>
                  ))}
                  <td className="text-end">
                    <strong>{number_format(dataset.total, 0, ",", ".")}</strong>
                  </td>
                </tr>
              ))}
              <tr>
                <td>&sum;</td>
                {data &&
                  data[0]?.data.map((header) => (
                    <td className="text-end">
                      <strong>
                        {number_format(
                          period.periods[header.description] || 0,
                          0,
                          ",",
                          "."
                        )}
                      </strong>
                    </td>
                  ))}
                <td className="text-end">
                  <strong>
                    {number_format(period?.total || 0, 0, ",", ".")}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const color = [
    "#D1B375",
    "#a1237f",
    "#B8E2B6",
    "#A3D8F4",
    "#F7B7D6",
    "#F8E0A1",
    "#D1B375",
    "#a1237f",
    "#B8E2B6",
    "#A3D8F4",
    "#F7B7D6",
    "#F8E0A1",
    "#D1B375",
    "#a1237f",
    "#B8E2B6",
    "#A3D8F4",
    "#F7B7D6",
    "#F8E0A1",
    "#D1B375",
    "#a1237f",
    "#B8E2B6",
    "#A3D8F4",
    "#F7B7D6",
    "#F8E0A1",
    "#D1B375",
    "#a1237f",
    "#B8E2B6",
    "#A3D8F4",
    "#F7B7D6",
    "#F8E0A1",
  ];

  const createPieChartData = (data) => {
    let dataFin = [];
    for (let i = 0; i < data.length; i++) {
      dataFin.push({ value: data[i].total, description: data[i].datasetName });
    }
    return dataFin;
  };

  const pieChart = (data, totalText) => {
    let numbers = [];
    let colors = color;
    let labels = [];
    let i = 0;
    let sum = 0;
    console.log("data", data);
    if (!data || data === false) {
      numbers = [100];
      colors = ["#f0f0f0"];
      labels = ["Nothing found"];
    } else {
      for (i = 0; i < data.length; i++) {
        numbers.push(data[i].value);
        sum += data[i].value;
        labels.push(data[i].description);
      }
    }
    if (sum === 0) {
      numbers = [100];
      colors = ["#f0f0f0"];
      labels = ["Nothing found"];
    }
    const match = totalText
      ? totalText.match(/([0-9.,]+[A-Za-z]?)\s([A-Za-z]+)/)
      : [];
    console.log("match", match);
    return (
      <div>
        <div
          style={{
            position: "relative",
            aspectRatio: "1/1",
            width: "100%",
          }}
        >
          <Doughnut
            data={{
              labels: labels,
              datasets: [
                {
                  data: numbers,
                  backgroundColor: colors,
                  borderWidth: 0,
                },
              ],
            }}
            options={{
              responsive: true,
              cutout: "70%",
              rotation: 225,
              circumference: 270,
              plugins: {
                tooltip: {
                  enabled: true,
                },
                legend: {
                  display: false,
                },
              },
            }}
          />
          <div
            style={{
              position: "absolute",
              left: "25%",
              top: "50%",
              width: "50%",
              textAlign: "center",
              fontSize: "2em",
              fontWeight: "bold",
            }}
          >
            {match ? (
              <>
                <div>{match[1]}</div>
                <div style={{ fontSize: "0.7em", color: "#aaa" }}>
                  {match[2]}
                </div>
              </>
            ) : (
              totalText
            )}
          </div>
        </div>
        {data.map((d, index) => (
          <div className="row">
            <div className="col-5" style={{ whiteSpace: "nowrap" }}>
              <span
                style={{
                  color: color[index % color.length],
                  fontSize: "1.6em",
                  lineHeight: "0.9em",
                  marginRight: "5px",
                }}
              >
                &#9679;
              </span>
              {d.description}
            </div>
            <div className="col-3 text-end">
              {number_format((d.value / sum) * 100, 0, ",", ".")}%
            </div>
            <div className="col-4 text-end">
              {number_format(d.value, 0, ",", ".")}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const barChart = (data) => {
    let datasets = [];
    let labels = [];
    let numbers = [];
    let i = 0;
    let j = 0;
    for (i = 0; i < data.length; i++) {
      numbers = [];
      console.log("x", data[i]);
      for (j = 0; j < data[i].data.length; j++) {
        if (i == 0) {
          labels.push(data[i].data[j].description);
        }
        numbers.push(data[i].data[j].value);
      }
      datasets.push({
        label: data[i].datasetName,
        data: numbers,
        backgroundColor: color[i],
        borderWidth: 0,
      });
    }
    return (
      <div>
        <Bar
          data={{ labels, datasets }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            scales: {
              x: {
                stacked: stack,
              },
              y: { stacked: stack },
              xAxes: [
                {
                  barThickness: 35, // Šířka sloupců
                  maxBarThickness: 40,
                  categoryPercentage: 0.5, // Nastavení mezery mezi sloupci
                  ticks: {
                    beginAtZero: true, // Začít osu X na nule
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true, // Začít osu Y na nule
                  },
                },
              ],
            },
            plugins: {
              legend: {
                display: true, // Zobrazit legendu
                position: "bottom", // Umístění legendy
              },
              tooltip: { enabled: true },
            },
          }}
        />
      </div>
    );
  };

  return (
    <>
      <OpportunitiesBusinessStatsModal
        filter={detailFilter}
        onHide={() => setDetailFilter(false)}
      />
      {yearData?.message && (
        <div className="alert alert-info">{yearData.message}</div>
      )}
      {yearStatsMutation.isLoading && (
        <div className="alert alert-info">{t("common.uploadingData")}...</div>
      )}
      <div className="d-flex">
        <select
          className="form-control"
          style={{ maxWidth: "300px" }}
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          {years.map((year) => (
            <option value={year}>{t("stats.year")} {year}</option>
          ))}
        </select>
        <span className="px-3 py-3">
          <Form>
            <Form.Check
              type="switch"
              id="type-switch"
              label={t("stats.stackValues")}
              checked={stack}
              onChange={(e) => setStack(e.target.checked)}
            />
          </Form>
        </span>
      </div>
      <h3 className="py-3">{t("stats.salesByVendorsYear").replace("{year}", year)}</h3>
      {yearStatsMutation.isLoading && !yearData ? (
        <div className="alert alert-info">{t("common.uploadingData")}...</div>
      ) : yearData && yearData.vendors && yearData.vendors.length > 0 ? (
        <>
          <div className="row d-flex">
            <div className="col-12 col-md-8 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body">
                  {yearData &&
                    yearData?.vendors?.length > 0 &&
                    barChart(yearData.vendors)}
                  {/*JSON.stringify(yearData?.vendors)*/}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body fs-6 fs-sm-10 fs-md-9 fs-lg-6">
                  {yearData &&
                    yearData?.vendors?.length > 0 &&
                    pieChart(
                      createPieChartData(yearData.vendors),
                      shortcat_number(yearData.period.total) + " CZK"
                    )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {yearData &&
                    yearData?.vendors?.length > 0 &&
                    tabData(yearData.vendors, yearData.period, "vendors")}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-danger">{t("common.noData")}...</div>
      )}
      <h3 className="py-3">{t("stats.salesBySalespersonsYear").replace("{year}", year)}</h3>
      {yearStatsMutation.isLoading && !yearData ? (
        <div className="alert alert-info">{t("common.uploadingData")}...</div>
      ) : yearData && yearData.persons && yearData.persons.length > 0 ? (
        <>
          <div className="row d-flex">
            <div className="col-md-8 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body">
                  {yearData &&
                    yearData?.persons?.length > 0 &&
                    barChart(yearData.persons)}
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-5 d-flex">
              <div className="card">
                <div className="card-body">
                  {yearData &&
                    yearData?.persons?.length > 0 &&
                    pieChart(
                      createPieChartData(yearData.persons),
                      shortcat_number(yearData.period.total) + " CZK"
                    )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="card w-100">
              <div className="card-body">
                {yearData &&
                  yearData?.persons?.length > 0 &&
                  tabData(yearData.persons, yearData.period, "person_id")}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-danger">{t("common.noData")}...</div>
      )}
      <hr className="my-10" />
      <h3 className="py-3">{t("stats.salesByVendorsYears")}</h3>
      {overallStatsMutation.isLoading && !overallData ? (
        <div className="alert alert-info">{t("common.uploadingData")}...</div>
      ) : overallData &&
        overallData.vendors &&
        overallData.vendors.length > 0 ? (
        <>
          <div className="row d-flex">
            <div className="col-12 col-md-8 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body">
                  {overallData &&
                    overallData?.vendors?.length > 0 &&
                    barChart(overallData.vendors)}
                  {/*JSON.stringify(overallData?.vendors)*/}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body fs-6 fs-sm-10 fs-md-9 fs-lg-6">
                  {overallData &&
                    overallData?.vendors?.length > 0 &&
                    pieChart(
                      createPieChartData(overallData.vendors),
                      shortcat_number(overallData.period.total) + " CZK"
                    )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {overallData &&
                    overallData?.vendors?.length > 0 &&
                    tabData(
                      overallData.vendors,
                      overallData.period,
                      "vendors",
                      true
                    )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-danger">{t("common.noData")}...</div>
      )}
      <h3 className="py-3">{t("stats.salesBySalespersonsYears")}</h3>
      {overallStatsMutation.isLoading && !overallData ? (
        <div className="alert alert-info">{t("common.uploadingData")}...</div>
      ) : overallData && overallData?.persons?.length > 0 ? (
        <>
          <div className="row d-flex">
            <div className="col-12 col-md-8 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body">
                  {overallData &&
                    overallData?.persons?.length > 0 &&
                    barChart(overallData.persons)}
                  {/*JSON.stringify(overallData?.persons)*/}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-5 d-flex">
              <div className="card w-100">
                <div className="card-body fs-6 fs-sm-10 fs-md-9 fs-lg-6">
                  {overallData &&
                    overallData?.persons?.length > 0 &&
                    pieChart(
                      createPieChartData(overallData.persons),
                      shortcat_number(overallData.period.total) + " CZK"
                    )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {overallData &&
                    overallData?.persons?.length > 0 &&
                    tabData(
                      overallData.persons,
                      overallData.period,
                      "person_id",
                      true
                    )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-danger">{t("common.noData")}...</div>
      )}
    </>
  );
}

export default BusinessStats;
